import { render, staticRenderFns } from "./UIDLabelPrintHistory.vue?vue&type=template&id=70b09aed"
import script from "./UIDLabelPrintHistory.vue?vue&type=script&lang=js"
export * from "./UIDLabelPrintHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports